import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ThankYou from "../pages/thank-you/page";
import CostCalculator from "../pages/cost-calculator/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/thank-you",
    element: <ThankYou />,
  },
  {
    path: "/cost-calculator",
    element: <CostCalculator />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
